<template>
  <div class="detail_content">
    <div class="detail_label">
      {{ titleLabel }}
    </div>
    <div class="tables-container">
      <div class="callApp">
        <table
          class="table_header"
          border="1"
          cellpadding="2"
          bordercolor="#fff"
          style="border-collapse: collapse; border: solid 1px #000000"
        >
          <tr>
            <th class="cell_ID">ID</th>
            <th class="cell_callAppName">アプリ名</th>
          </tr>
          <tr
            v-for="callApp in callAppList"
            :key="callApp.id"
            class="item_callApp_table_row"
          >
            <td class="cell_ID">
              {{ callApp.id }}
            </td>
            <td class="cell_callAppName">
              {{ callApp.callAppName }}
            </td>
          </tr>
        </table>
      </div>
      <div class="callApp changed-table" v-if="isChanged">
        <table
          class="table_header"
          border="1"
          cellpadding="2"
          bordercolor="#fff"
          style="border-collapse: collapse; border: solid 1px #000000"
        >
          <tr>
            <th class="cell_ID">ID</th>
            <th class="cell_callAppName">アプリ名</th>
          </tr>
          <tr
            v-for="callApp in changeCallAppList"
            :key="callApp.id"
            class="item_callApp_table_row"
          >
            <td class="cell_ID">
              {{ callApp.id }}
            </td>
            <td class="cell_callAppName">
              {{ callApp.callAppName }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    isChanged: Boolean,
    callAppList: Array,
    changeCallAppList: Array
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.tables-container {
  display: flex;
  gap: 20px;
}
.callApp {
  min-width: 200px;
  flex: 1;
}
.item_callApp_table_row {
  height: 40px;
  background-color: #fff;
  color: #4a4a4a;
}
.cell_ID {
  width: 30px;
}
.cell_callAppName {
  width: 170px;
}
.changed-table td {
  color: #d32f2f !important;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/updateCallAppListSection.vue